import createAxios from 'config/axios'

export const getCustodyAndPosition = async () => createAxios.get('samwise/v2/custody-position')

export default getCustodyAndPosition
